<template>
	<div class="measure-blood-pressure">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<d3-blood-pressure :values="values"/>
	</div>
</template>

<script>
import D3BloodPressure from './D3BloodPressure'
export default {
	components: {
		D3BloodPressure
	},
	props: [
		'value'
	],
	computed: {
		values () {
			return {
				systolic: this.value.values.systolic_last || 0,
				diastolic: this.value.values.diastolic_last || 0
			}
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/MeasureBloodPressure.vue